'use client'

import MUITable from '@mui/material/Table'
import MUITableBody from '@mui/material/TableBody'
import MUITableCell from '@mui/material/TableCell'
import MUITableHead from '@mui/material/TableHead'
import MUITableRow from '@mui/material/TableRow'
import MUITypography from '@mui/material/Typography'

export type FiguresReviewRow = {
  category: string
  amount: number
}

export type FiguresReviewTableProps = {
  rows: FiguresReviewRow[]
  title?: string
}

const formatCurrency = (amount: number) =>
  new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount)

// Read-only category-rows + computed-total review table shared by the ITSA
// cumulative-period/annual-summary review screens (FE7b, FE8). Purely presentational —
// the category set and amounts are supplied by the caller (via the HmrcMtdItsaCategory
// mapping data already fetched in useHMRCITSAStore); this component does no fetching.
export const FiguresReviewTable = ({ rows, title }: FiguresReviewTableProps) => {
  const total = rows.reduce((sum, row) => sum + row.amount, 0)

  return (
    <div data-testid="FiguresReviewTable">
      {title && (
        <MUITypography variant="h6" sx={{ mb: 2 }}>
          {title}
        </MUITypography>
      )}
      <MUITable size="small">
        <MUITableHead>
          <MUITableRow>
            <MUITableCell>Category</MUITableCell>
            <MUITableCell align="right">Amount</MUITableCell>
          </MUITableRow>
        </MUITableHead>
        <MUITableBody>
          {rows.map((row) => (
            <MUITableRow key={row.category} data-testid="FiguresReviewTable-row">
              <MUITableCell>{row.category}</MUITableCell>
              <MUITableCell align="right">{formatCurrency(row.amount)}</MUITableCell>
            </MUITableRow>
          ))}
          <MUITableRow data-testid="FiguresReviewTable-totalRow">
            <MUITableCell sx={{ fontWeight: 700, borderTop: '2px solid', borderColor: 'lines.slate300' }}>
              Total
            </MUITableCell>
            <MUITableCell align="right" sx={{ fontWeight: 700, borderTop: '2px solid', borderColor: 'lines.slate300' }}>
              {formatCurrency(total)}
            </MUITableCell>
          </MUITableRow>
        </MUITableBody>
      </MUITable>
    </div>
  )
}
